const mediaItems = [
  {
    title: '独家揭秘：某综艺节目后台冲突全程',
    duration: '15:28',
    views: '256万',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20backstage%20TV%20studio%20corridor%20with%20warm%20spotlight%20and%20deep%20shadows%2C%20two%20silhouetted%20figures%20in%20tense%20confrontation%2C%20cinematic%20behind%20the%20scenes%20photography%2C%20professional%20broadcast%20equipment%20in%20background&width=800&height=450&seq=media-01-backstage&orientation=landscape',
  },
  {
    title: '明星红毯翻车名场面合集',
    duration: '08:42',
    views: '189万',
    image: 'https://readdy.ai/api/search-image?query=Glamorous%20red%20carpet%20event%20with%20dramatic%20fashion%20moments%2C%20flashing%20paparazzi%20cameras%2C%20celebrities%20in%20luxury%20outfits%2C%20warm%20golden%20spotlight%20beams%2C%20cinematic%20event%20photography%20with%20elegant%20composition&width=800&height=450&seq=media-02-redcarpet&orientation=landscape',
  },
  {
    title: '网红直播间翻车实录',
    duration: '12:15',
    views: '312万',
    image: 'https://readdy.ai/api/search-image?query=Professional%20livestreaming%20studio%20setup%20with%20dramatic%20ring%20light%20and%20product%20display%2C%20warm%20glamorous%20lighting%2C%20modern%20e-commerce%20broadcast%20equipment%2C%20cinematic%20behind%20the%20scenes%20documentary%20style&width=800&height=450&seq=media-03-livestream&orientation=landscape',
  },
  {
    title: '2026上半年娱乐大事件速览',
    duration: '20:05',
    views: '478万',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20entertainment%20news%20montage%20visual%20with%20dramatic%20red%20curtain%20and%20golden%20spotlight%2C%20floating%20headlines%20in%20warm%20ambient%20glow%2C%20grand%20theater%20stage%20atmosphere%2C%20professional%20media%20production%20aesthetic&width=800&height=450&seq=media-04-roundup&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-12 md:py-16 bg-background-100">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
            精彩视频
          </h2>
          <p className="mt-2 text-sm text-foreground-500">热门爆料视频精选推荐</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {mediaItems.map((item, i) => (
            <article
              key={i}
              className="group bg-background-50 rounded-xl border border-background-200/60 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden bg-background-100">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                  onError={(e) => {
                    (e.target as HTMLImageElement).style.display = 'none';
                  }}
                />
                {/* Play button overlay */}
                <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
                  <div className="w-10 h-10 rounded-full bg-background-50/90 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill text-lg text-primary-500 group-hover:text-background-50 transition-colors ml-0.5"></i>
                  </div>
                </div>
                {/* Duration */}
                <span className="absolute bottom-2 right-2 px-1.5 py-0.5 text-xs font-medium text-background-50 bg-black/70 rounded whitespace-nowrap">
                  {item.duration}
                </span>
                {/* Views */}
                <span className="absolute top-2 right-2 px-1.5 py-0.5 text-xs text-background-50 bg-black/50 rounded whitespace-nowrap flex items-center gap-1">
                  <i className="ri-eye-line text-xs"></i>
                  {item.views}
                </span>
              </div>
              <div className="p-3">
                <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-500 transition-colors line-clamp-2">
                  {item.title}
                </h3>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}